import React, {useState} from 'react';
import './App.scss';
import Login from './Pages/Login';
import Patients from './Pages/Patients';
import AddPatient from './Pages/Patients/AddPatient';
import { Row } from 'antd';
import { Switch, Route, Redirect } from 'react-router-dom';
import EditPatient from "./Pages/Patients/EditPatient";
import AttendingPanel from './Pages/AttendingPanel';
import { useUser, useAuth } from 'reactfire';
import {StoreProvider} from './Context/store';
import AppintmentHistory from './Pages/Appointment_History';

import ManageInvestigations from './Pages/ManageInvestigations';
import ManageDiagnosis from './Pages/ManageDiagnosis';
import ManageMedicine from './Pages/ManageMedicine';

import { Offline, Online } from "react-detect-offline"


function App() {

  // let currentuser = useUser();
  const [isUserLoggedIn, setLogin] = useState(false);
  // // let isUserLoggedIn = FALSE;
  // if(currentuser) {
  //   setLogin(true);
  // } else {
  //   setLogin(false);
  // }
  // console.log('Currnt user is : ',currentuser);

  const auth = useAuth();
  auth.onAuthStateChanged(user => {
    if(user) {
      setLogin(true);
    } else {
      setLogin(false);
    }
  });


  return (
    <div className="App">

<div>
            <Offline><div className="connectivityStatus onlines"></div></Offline>
            <Online><div className="connectivityStatus offlines"></div></Online>
        </div>


<StoreProvider>
      <Row>

        <Switch>
          
            <Route exact path='/login'>
              {!isUserLoggedIn ? <Login /> :  <Redirect from="/login" to="/patients" />}
              {/* <Login /> */}
            </Route>
  
            <Route exact path='/patients'>
            {!isUserLoggedIn ?  <Redirect to="/login" /> :<Patients />}
            </Route>

            <Route exact path='/manage_investigations'>
            {!isUserLoggedIn ?  <Redirect to="/login" /> :<ManageInvestigations />}
            </Route>

            <Route exact path='/manage_diagnosis'>
            {!isUserLoggedIn ?  <Redirect to="/login" /> :<ManageDiagnosis />}
            </Route>

            <Route exact path='/manage_medicine'>
            {!isUserLoggedIn ?  <Redirect to="/login" /> :<ManageMedicine />}
            </Route>

            <Route exact path='/add_patients'>
            {!isUserLoggedIn ?  <Redirect to="/login" /> : <AddPatient />}
            </Route>
            <Route exact path='/edit_patient/:id'>
            {!isUserLoggedIn ?  <Redirect to="/login" /> : <EditPatient />}
            </Route>
            <Route exact path='/attending_patient/:id/:appointmentId'>
            {!isUserLoggedIn ?  <Redirect to="/login" /> : <AttendingPanel />}
            </Route>
            <Route exact path='/appointment_hisotry/:id/'>
            {!isUserLoggedIn ?  <Redirect to="/login" /> :  <AppintmentHistory />}
            </Route>

        
            {isUserLoggedIn ? <Redirect from="/" to="/login" /> : <Redirect from="/" to="/patients" />}

          </Switch>
      </Row>
      </StoreProvider>
    </div>
  );
}

export default App;
